import {
  Dispatch,
  SetStateAction,
  SyntheticEvent,
  useEffect,
  useState,
} from 'react';
import ModalComponent from '../../../../components/ModalComponent';
import { Box } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import Tab from '@mui/material/Tab';
import DvrChannelsConfigTab from './DvrChannelsConfigTab';
import DvrAlarmEntriesConfigTab from './DvrAlarmEntriesConfigTab';

interface IDvrDeviceConfigModalProps {
  isOpen: boolean;
  selectedDevice?: any;
  setSelectedDevice?: Dispatch<SetStateAction<any>>;
  onClose?: () => void;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

const DvrDeviceConfigModal = ({
  isOpen,
  selectedDevice,
  setSelectedDevice,
  onClose,
  setIsOpen,
}: IDvrDeviceConfigModalProps) => {
  const [tab, setTab] = useState('1');

  const onChangeTab = (event: SyntheticEvent, value: string) => setTab(value);

  const handleClose = () => {
    setIsOpen(false);
    if (setSelectedDevice) setSelectedDevice({});
  };

  return (
    <ModalComponent
      onClose={handleClose}
      isOpen={isOpen}
      title={'Configurações DVR/NVR'}
    >
      <TabContext value={tab}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={onChangeTab}>
            <Tab label="Canais" value="1" />
            <Tab label="Entradas de Alarme" value="2" />
          </TabList>
        </Box>
        <TabPanel value="1">
          <DvrChannelsConfigTab selectedDevice={selectedDevice} />
        </TabPanel>
        <TabPanel value="2">
          <DvrAlarmEntriesConfigTab selectedDevice={selectedDevice} />
        </TabPanel>
      </TabContext>
    </ModalComponent>
  );
};

export default DvrDeviceConfigModal;
